import { useContext } from 'react'
import { SessionContext as WebSessionContext } from '@contexts/WebSessionContext'
import {
  SessionContext as AppSessionContext,
  ISessionProviderProps,
} from '@contexts/AppSessionContext'
import { isWeb } from 'tamagui'
export const useSession = () => {
  const context = isWeb ? WebSessionContext : AppSessionContext
  return useContext(context as React.Context<ISessionProviderProps>)
}
